import './index.css';
import { useContext } from 'react';
import { createPortal } from 'react-dom';
import { BottomSheetContext } from './BottomSheetContext.js';

const BottomSheetContentOverlay = ({ children }) => {
    const { contentOverlayRef } = useContext(BottomSheetContext);
    return contentOverlayRef.current !== null ? createPortal(children, contentOverlayRef.current) : null;
};

export { BottomSheetContentOverlay };
//# sourceMappingURL=BottomSheetContentOverlay.js.map
